/**
 * Keep only the report-visible part of question/statement text.
 *
 * - if `||` exists, keep text after it
 * - then if `|` exists, keep text before it
 */
export function shortQuestion(text: string): string {
  const doublePipePos = text.indexOf('||');

  if (doublePipePos !== -1) {
    text = text.slice(doublePipePos + 2);
  }

  const singlePipePos = text.indexOf('|');
  if (singlePipePos !== -1) {
    text = text.slice(0, singlePipePos);
  }

  return text;
}
